/**
 * Maps an unmapped tool name to a generic `activityTrail.generic.*` key by
 * keyword. The trail is always on, so tools with no per-tool config (or tenants
 * with no tool group) still surface a row; tenants with bespoke copy never reach here.
 */
const GENERIC_LABEL_RULES: { match: RegExp; key: string }[] = [
  // Must precede `dates` — "update" contains "date", so update-type tools would
  // otherwise mislabel as "checking dates".
  { match: /(update|upsert|edit|save|submit|contact)/i, key: 'activityTrail.generic.update' },
  { match: /(date|availab|calendar)/i, key: 'activityTrail.generic.dates' },
  { match: /(filter|refine|facet|subcategor|sort)/i, key: 'activityTrail.generic.filters' },
  { match: /(knowledge|faq|policy)/i, key: 'activityTrail.generic.knowledge' },
  { match: /(detail|describe|spec|info)/i, key: 'activityTrail.generic.details' },
  {
    match: /(search|find|lookup|query|list|browse|explore|get|fetch)/i,
    key: 'activityTrail.generic.search',
  },
];

/** Returns the `activityTrail.generic.*` translation key for an unmapped tool. */
export function genericTrailLabelKey(toolName: string): string {
  for (const rule of GENERIC_LABEL_RULES) {
    if (rule.match.test(toolName)) return rule.key;
  }
  return 'activityTrail.generic.working';
}
